Controller.$inject = [];

function Controller() {
    const self = this;

    self.sortingType = 'asc';

    self.sortTableColumn =  (direction) => {
        if (self.sortingType === direction) {
            self.sortingType = direction === 'asc' ? 'desc' : 'asc';
        } else {
            self.sortingType = direction;
        }

        if (self.onSortChanged) {
            self.onSortChanged({ direction: self.sortingType });
        }
    };

}

export function HuiCell() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            stickyTop: '@',
            stickyBottom: '@',
            stickyStart: '@',
            stickyEnd: '@',
            as: '@',
            isDisabled: '<',
            isSortable: '<',
            onSortChanged: '&',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {

            const tagName = $attrs.as || 'td';

            return `
                <${tagName} ng-class="{
                    'stuck': $huiCtrl.stickyTop || $huiCtrl.stickyBottom || $huiCtrl.stickyStart || $huiCtrl.stickyEnd,
                    'stuck-top': $huiCtrl.stickyTop,
                    'stuck-bottom': $huiCtrl.stickyBottom,
                    'stuck-start': $huiCtrl.stickyStart,
                    'stuck-end': $huiCtrl.stickyEnd,
                    'disabled': $huiCtrl.isDisabled,
                }"
                 ng-style="{
                   top: $huiCtrl.stickyTop,
                   bottom: $huiCtrl.stickyBottom,
                   left: $huiCtrl.stickyStart,
                   right: $huiCtrl.stickyEnd,
                 }">
                 <span ng-transclude ng-if="!$huiCtrl.isSortable"></span>
                 <div class="d-flex gap-1" ng-if="$huiCtrl.isSortable">
                
                 <span ng-transclude></span>
                 
                 <span class="hui-sort-icons justify-content-center" ng-if="$huiCtrl.isSortable">
                        <i class="fa-caret-up"
                           ng-class="{'fa-solid': $huiCtrl.sortingType === 'asc', 'fa-light': $huiCtrl.sortingType !== 'asc'}"
                           ng-click="$huiCtrl.sortTableColumn('asc')">
                        </i>
                        <i class="fa-caret-down"
                           ng-class="{'fa-solid': $huiCtrl.sortingType === 'desc', 'fa-light': $huiCtrl.sortingType !== 'desc'}"
                           ng-click="$huiCtrl.sortTableColumn('desc')">
                        </i>
                    </span>
                </div>      
             </${tagName}>
            `;
        }
    }
}